import { createSelector } from '@reduxjs/toolkit';
import { AnalogDut, AnalogInput, BoilerAdapter, DigitalDut, RadioSensor, RadioSensor433, } from 'z3k-config';
import { OpenThermVariableName } from 'openTherm';
import { isBatteryVoltageInput, isPowerVoltageInput, } from 'z3k-parser/model/device-spec/io-extensions-spec';
import { boiler_adapter_ot_color } from 'z3k-settings/components/utils/ColorPicker4bit';
import { selectEnabledBoilerAdapters } from '../../utils/open-therm';
import { analog_sensors_icons, radio_sensors_433_icons, radio_sensors_icons, } from './icons';
import { fixObjectName } from 'z3k-settings/utils/fix-object-name';
export function voltageInput(z3k_config, physical_input_num) {
    if (isPowerVoltageInput(z3k_config, physical_input_num)) {
        return 'ac';
    }
    if (isBatteryVoltageInput(z3k_config, physical_input_num)) {
        return 'battery';
    }
    return '';
}
export const selectSensors = createSelector(AnalogDut.get.all, DigitalDut.get.all, (z3k_config) => RadioSensor.get.where(z3k_config, RadioSensor.isDisplayable), RadioSensor433.get.all, AnalogInput.get.all, selectEnabledBoilerAdapters, (ads, dds, rs, rs433, ais, boiler_adapter_sensors) => {
    return [
        ...ads,
        ...dds,
        ...rs,
        ...rs433,
        ...ais,
        ...boiler_adapter_sensors.flatMap(BoilerAdapter.getAvailableOTParams),
    ];
});
export function getAnalogInputSensor(z3k_config, sensor) {
    const { id, name, physical_input_num } = sensor;
    const type = AnalogInput.getType(sensor);
    const icon = AnalogInput.isAnalogInputType(sensor)
        ? voltageInput(z3k_config, physical_input_num)
        : analog_sensors_icons[type];
    const limits = AnalogInput.getLimits(sensor);
    const unit = AnalogInput.booleanSensorsTypes.includes(type)
        ? undefined
        : AnalogInput.getUnit(sensor);
    const success_active = [
        AnalogInput.Type.IGNITION,
        AnalogInput.Type.DISCRETE,
    ].includes(type);
    return {
        id,
        name: fixObjectName(name),
        icon,
        unit,
        type,
        limits,
        success_active,
    };
}
export function getRadioSensor(sensor) {
    const { id, name, type } = sensor;
    const is_humidity_sensor = type === RadioSensor.Type.HUMIDITY;
    const limits = is_humidity_sensor
        ? RadioSensor.getHumidityLimits(sensor)
        : RadioSensor.getLimits(sensor);
    const unit = is_humidity_sensor ? '%' : undefined;
    const icon = radio_sensors_icons[type];
    return {
        id,
        name: fixObjectName(name),
        icon,
        type,
        unit,
        limits,
    };
}
export function getRadioSensor433(sensor) {
    const { id, name, type } = sensor;
    const icon = radio_sensors_433_icons[RadioSensor433.getType(sensor)];
    const limits = null;
    return {
        id,
        icon,
        name: fixObjectName(name),
        type,
        limits,
    };
}
export function getBoilerAdapterSensor(sensor, index) {
    const { id: boiler_adapter_id, name, ot_name } = sensor;
    const id = (boiler_adapter_id + Number(`0.0${index}`));
    const sensor_type = ot_name === OpenThermVariableName.rml
        ? AnalogInput.Type.HUMIDITY_SENSOR
        : AnalogInput.Type.PRESSURE_SENSOR_5;
    const unit = AnalogInput.getUnit({
        sensor_type,
    });
    const open_therm = {
        boiler_adapter_id,
        ot_name,
    };
    // change on sensor component
    const limits = {
        low: sensor.lower_threshold,
        high: 3,
    };
    return {
        id,
        name,
        limits,
        open_therm,
        unit: ot_name === OpenThermVariableName.fr ? 'л/мин' : unit,
        color: boiler_adapter_ot_color[0],
    };
}
